import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {MatInputModule} from '@angular/material/input';
import {CommandService} from '@core/services/command.service';
import {SupportOrbitaxHandler} from '@features/task-manager/services/support-orbitax.handler';
import {SupportOrbitaxDynamicComponentHelper} from '@features/support/support-orbitax-dynamic-component-helper';
import {PlatformCommand} from '@shared/commands/command-base';
import {Api} from '@shared/constants/common-field.constants';
import {SharedModule} from '@shared/shared.module';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatChipsModule} from '@angular/material/chips';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {supportRoutes} from '@features/support/support.routes';
import { SolutionNamesCellViewerComponent } from './components/solution-names-cell-viewer/solution-names-cell-viewer.component';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import {SecurityModule} from '@features/security/security.module';
import { SupportConfigurationComponent } from './components/support-configuration/support-configuration.component';
import { ExcludeTestCompaniesComponent } from './components/exclude-test-companies/exclude-test-companies.component';
import {PlatformApiProvider} from '@shared/services/platform-api-provider';
import { SupportEmailConfigurationComponent } from './components/support-email-configuration/support-email-configuration.component';
import { ParticleCacheService } from '@core/services/particle-cache.service';

@NgModule({
  declarations: [
    SolutionNamesCellViewerComponent,
    SupportConfigurationComponent,
    ExcludeTestCompaniesComponent,
    SupportEmailConfigurationComponent,
],
  imports: [
    CommonModule,
    SharedModule,
    SecurityModule,
    RouterModule.forChild(supportRoutes),
    MatAutocompleteModule,
    MatChipsModule,
    MatInputModule,
    ClipboardModule,
    TooltipModule,
  ],
  providers: [
  ]
})
export class SupportModule {
  constructor(private commandService: CommandService,
              private supportOrbitaxHandler: SupportOrbitaxHandler,
              private platformApiProvider: PlatformApiProvider,
              private particleCacheService: ParticleCacheService) {
    this.platformApiProvider.registerDefault(Api.TaskManager, '/dashboard');

    SupportOrbitaxDynamicComponentHelper.init();
    SupportOrbitaxDynamicComponentHelper.register('SupportOrbitaxHandler', supportOrbitaxHandler);
    let command = new PlatformCommand('SupportListToolLinkCommand', Api.TaskManager);
    command.fieldValues['ViewType'] = 'ListView';
    command.fieldValues['OrbitaxSupport'] = true;
    command.waitForResponse = true;
    this.commandService.registrPlatformLinkCommand('/task-manager/support/grid', command);
    this.commandService.registrPlatformLinkCommand('/:taskId', command);
    this.commandService.registrPlatformLinkCommand('/', command);

    command = new PlatformCommand('SupportListToolLinkCommand', Api.TaskManager);
    command.fieldValues['ViewType'] = 'CardView';
    command.fieldValues['OrbitaxSupport'] = true;
    command.waitForResponse = true;
    this.commandService.registrPlatformLinkCommand('/task-manager/support/card', command);

    command = new PlatformCommand('SupportDashboardWidgetToolLinkCommand', Api.TaskManager);
    command.fieldValues['OrbitaxSupport'] = true;

    command.fieldValues['HideAnalytics'] = this.particleCacheService.getItemFromSessionStorage(this.getSupportKey('HideAnalytics'))?.value ?? true;
    command.fieldValues['ShowArchived'] = this.particleCacheService.getItemFromSessionStorage(this.getSupportKey('ShowArchived'))?.value;
    command.fieldValues['ShowTestCompanies'] = this.particleCacheService.getItemFromSessionStorage(this.getSupportKey('ShowTestCompanies'))?.value;
    command.fieldValues['StartDate'] = this.particleCacheService.getItemFromSessionStorage(this.getSupportKey('StartDate'))?.value;
    command.fieldValues['EndDate'] = this.particleCacheService.getItemFromSessionStorage(this.getSupportKey('EndDate'))?.value;
    command.fieldValues['IsDateFilterEnabled'] = this.particleCacheService.getItemFromSessionStorage(this.getSupportKey('IsDateFilterEnabled'))?.value;

    command.waitForResponse = true;
    this.commandService.registrPlatformLinkCommand('/dashboard', command);

    command = new PlatformCommand('SupportConfigurationCommand', Api.TaskManager);
    this.commandService.registrPlatformLinkCommand('/support-configuration', command);
  }

  private getSupportKey(key: string) {
    return this.supportOrbitaxHandler.getSupportKey(key);
  }
}

